import ZOOMIN from "../../../assets/zoom-in.svg";
import ZOOMOUT from "../../../assets/zoom-out.svg";
import ROTATE from "../../../assets/rotate.svg";

function ButtionArea({
    imageProperty,
    setImageProperty
}) {

    const zoomHandler = (value) => {
        let currentWidth = imageProperty.width;
        if ((value === -100 && currentWidth <= 200) || (value === 100 && currentWidth >= 2000)) {
            return; // Do nothing if the current width is at its limit
        }
        // Update the image property based on the provided value
        setImageProperty(prevState => ({
            ...prevState,
            width: prevState.width + value
        }));
      }
    
      const rotateHandler = () => {
        let angleList = [0, 90, 180, 270, 360]
        let currentAngle = imageProperty.angle
        let nextAngleIndex = angleList.indexOf(currentAngle) + 1
        if(nextAngleIndex === 4){
          nextAngleIndex = 0
        }
        setImageProperty(prevState => ({
          ...prevState,
          angle: angleList[nextAngleIndex]
      }));
      }
  return (
    <div className="reconcilation__verification__button__area">
      <button
        className="reconcilation__verification__button"
        disabled={imageProperty.width <= 200}
        onClick={() => zoomHandler(-100)}
      >
      <img src={ZOOMOUT} alt="ZOOM OUT"/>
      </button>
      <button
        disabled={imageProperty.width >= 2000}
        className="reconcilation__verification__button"
        onClick={() => zoomHandler(+100)}
      >
      <img src={ZOOMIN} alt="ZOOM IN"/>
      </button>
      <button
        className="reconcilation__verification__button center"
        onClick={rotateHandler}
      >
      <img src={ROTATE} style={{width: '60%'}} alt="ROTATE"/>
      </button>
    </div>
  )
}

export default ButtionArea